import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function ZoomEmbed({ userName }) {
  const iframeRef = useRef(null);
  const [status, setStatus] = useState('loading');
  const [errorMsg, setErrorMsg] = useState('');
  const sentConfig = useRef(false);

  useEffect(() => {
    const handleMessage = async (event) => {
      if (event.data?.type === 'ZOOM_READY' && !sentConfig.current) {
        sentConfig.current = true;
        try {
          setStatus('joining');
          const { data: config } = await axios.get(`${API}/live/zoom-config`);
          iframeRef.current?.contentWindow?.postMessage({
            type: 'ZOOM_JOIN',
            config: {
              ...config,
              userName: config.userName || userName || 'Estudiante',
            }
          }, '*');
          // Give it time to join
          setTimeout(() => setStatus('connected'), 3000);
        } catch (err) {
          setErrorMsg(err.response?.data?.detail || 'Error al obtener configuración');
          setStatus('error');
          toast.error('Error al conectar con Zoom');
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [userName]);

  return (
    <div className="glass-panel rounded-lg overflow-hidden relative" data-testid="zoom-embed-container">
      {status !== 'connected' && (
        <div className="absolute inset-0 z-10 flex items-center justify-center bg-[#020402]">
          {(status === 'loading' || status === 'joining') && (
            <div className="text-center">
              <Loader2 className="h-8 w-8 text-blue-400 animate-spin mx-auto mb-3" />
              <p className="text-emerald-100/70 text-sm">
                {status === 'loading' ? 'Cargando Zoom...' : 'Uniéndose a la sesión...'}
              </p>
            </div>
          )}
          {status === 'error' && (
            <div className="text-center px-6">
              <p className="text-red-400 font-bold mb-2">Error al conectar con Zoom</p>
              <p className="text-emerald-100/50 text-xs">{errorMsg}</p>
              <button onClick={() => window.location.reload()} className="mt-3 text-emerald-400 text-sm hover:underline">
                Reintentar
              </button>
            </div>
          )}
        </div>
      )}
      <iframe
        ref={iframeRef}
        src="/zoom-client.html"
        title="Zoom Meeting"
        allow="microphone; camera; display-capture; fullscreen; autoplay"
        style={{ width: '100%', aspectRatio: '16/9', border: 'none', display: 'block' }}
        data-testid="zoom-iframe"
      />
    </div>
  );
}
